import callApi from 'lib/callApi';
import { toast } from 'react-toastify';

import axios from './axiosInstance';

const refreshAccessToken = async function () {
  let refresh = localStorage.getItem('refresh');
  if (refresh) {
    let data = {
        refresh: refresh,
      },
      url = '/api/token/refresh/';
    await axios
      .post(url, data)
      .then((res) => {
        if (res.status === 200) {
          localStorage.setItem('access', res.data.access);
          localStorage.setItem('accessTokenSetAt', new Date());
        } else if (res.status === 401 || res.status === 400) {
          redirectToLogin();
        }
      })
      .catch((err) => {
        redirectToLogin();
      });
  } else {
    redirectToLogin();
  }
};
const setDeviceInfo = async function (user, password, remember_me) {
  try {
    let device_uid = localStorage.getItem('device_uid');
    if (device_uid === undefined || device_uid === '' || device_uid === null) {
      var dateObject = new Date();
      device_uid =
        dateObject.getFullYear() +
        '' +
        dateObject.getMonth() +
        '' +
        dateObject.getDate() +
        '' +
        dateObject.getTime();
      localStorage.setItem('device_uid', device_uid);
    }
    let data = {
        user: user,
        password: password,
        remember_me: remember_me,
        device_id: device_uid,
      },
      headers = {},
      url = '/devices/';
    let response = await axios.post(url, data, {
      headers: headers,
    });
    if (response.status === 201 || response.status === 202) {
      return response.data;
    }
  } catch (err) {
    if (err.response.status === 422) {
      toast.error(err.response.data.error);
      throw err.response;
    }
  }
};
const verifyDeviceInfo = async function (token, remember_me) {
  let headers = {
      Authorization: 'Bearer ' + localStorage.getItem('access'),
    },
    url = '/devices/' + localStorage.getItem('device_uid') + '/check/';
  await axios
    .get(url, {
      headers: headers,
    })
    .then((res) => {
      if (res.status === 200) {
        if (res.data.otp_verified_at == null) {
          localStorage.removeItem('access');
          localStorage.removeItem('refresh');
          localStorage.removeItem('accessTokenSetAt');
          localStorage.setItem(btoa('approle'), btoa('guest'));
          localStorage.removeItem('verified_at');
        } else {
          if (res.data.is_admin === true) {
            localStorage.setItem(btoa('approle'), btoa('admin'));
          } else {
            localStorage.setItem(btoa('approle'), btoa('guest'));
          }
          localStorage.setItem('verified_at', res.data.otp_verified_at);
        }
      }
    })
    .catch((err) => {
      let res = err.response;
      if (res.status === 401 || res.status === 400) {
        localStorage.removeItem('access');
        localStorage.removeItem('refresh');
        localStorage.removeItem('accessTokenSetAt');
      }
    });
};
const verifyAccessToken = async function () {
  let data = {
      token: localStorage.getItem('access'),
    },
    url = '/api/token/verify/',
    refresh = false;
  await axios
    .post(url, data)
    .then((res) => {
      if (res.status === 200) {
        localStorage.setItem('last_path', window.location.pathname);
      } else if (res.status === 401 || res.status === 400) {
        refresh = true;
      }
    })
    .catch((err) => {
      refresh = true;
    });
  if (refresh === true) {
    let refreshAccessKey = localStorage.getItem('refresh');
    if (refreshAccessKey !== undefined && refreshAccessKey !== '')
      await refreshAccessToken();
  } else {
    if (
      localStorage.getItem('verified_at') === null ||
      localStorage.getItem('verified_at') === undefined ||
      localStorage.getItem('verified_at') === ''
    )
      await verifyDeviceInfo();
  }
};

const logOut = async function () {
  let url = `devices/user/logout/`;
  await callApi(url, 'GET', {})
    .then((res) => {
      // do nothing
    })
    .catch((err) => {
      let res = err.response;
      if (res.status === 401 || res.status === 400) {
        redirectToLogin();
      }
    });

  redirectToLogin();
};

const ensureAccessTokenVerified = function () {
  let accessToken = localStorage.getItem('access');
  let verified_at = localStorage.getItem('verified_at');
  if (
    !verified_at ||
    verified_at === undefined ||
    verified_at === 'undefined' ||
    !accessToken?.length > 0
  ) {
    redirectToLogin();
  }
};

const resetAuthLocalStorage = function () {
  localStorage.removeItem('access');
  localStorage.removeItem('refresh');
  localStorage.removeItem('accessTokenSetAt');
  localStorage.removeItem('verified_at');
};

const redirectToLogin = function () {
  resetAuthLocalStorage();
  window.location.href = '/login';
};

export {
  refreshAccessToken,
  verifyAccessToken,
  logOut,
  setDeviceInfo,
  verifyDeviceInfo,
  ensureAccessTokenVerified,
  redirectToLogin,
  resetAuthLocalStorage,
};
